import {Heading, HStack, Icon, Text, VStack} from 'platform/foundation';

import {CardOo} from '../../components/CardOo/CardOo';
import {translateWithFallback as t} from '../../utils/translateWithFallback';

export function VehicleIsYoursCard() {
  return (
    <CardOo backgroundColor="semantic.bg.green">
      <VStack spacing={2} data-testid="vehicleIsYoursCard">
        <HStack spacing={2} align="center">
          <Icon value="good" size={5} color="text.successDark" />
          <Heading size={4} color="successDark">
            {t('afterSale.vehicleIsYours.title', 'The vehicle is yours')}
          </Heading>
        </HStack>
        <Text size="small" color="secondary">
          {t(
            'afterSale.vehicleIsYours.message',
            'Thank you for your purchase. We hope you enjoy every kilometre.'
          )}
        </Text>
      </VStack>
    </CardOo>
  );
}
